import { useState } from 'react'
import { Grid, Typography } from '@material-ui/core'
import Radio from '../../../control/radio/radio'
import MyTextfield from '../../../control/textfield/textfield'

import useTranslate from '../../../i18n/useTranslate'
import { useForm } from 'react-final-form'

const Approve = () => {
    const translate = useTranslate()
    const form = useForm()

    const [reject, setReject] = useState(false)

    const onChangeResult = (value: string) => {
        if (value === '2') {
            setReject(false)
            if (form.getFieldState('reasonReject')?.value || form.getFieldState('langReason')?.value) {
                form.change('reasonReject', null)
                form.change('langReason', 'th')
            }
        } else setReject(true)
    }

    const caseReject = () => {
        if (reject) {
            return (
                <>
                    <Grid item xs={12}>
                        <MyTextfield
                            name="reasonReject"
                            materialInputProps={{
                                label: translate.get('UM.APPROVE-RESEARCHER.REJECT-REASON'),
                                disabled: false,
                                placeholder: translate.get('UM.APPROVE-RESEARCHER.REJECT-REASON'),
                                size: 'medium',
                                rows: 5,
                                multiline: true,
                            }}
                            required
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Radio
                            name="langReason"
                            options={[
                                { id: 'th', name: translate.get('UM.APPROVE-RESEARCHER.CHOOSE_EMAIL_TH') },
                                { id: 'en', name: translate.get('UM.APPROVE-RESEARCHER.CHOOSE_EMAIL_EN') },
                            ]}
                            required
                        />
                    </Grid>
                </>
            )
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                    {translate.get('UM.APPROVE-RESEARCHER.RESULT')}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Radio
                    name="result"
                    options={[
                        { id: '2', name: translate.get('UM.APPROVE-RESEARCHER.APPROVE') },
                        { id: '3', name: translate.get('UM.APPROVE-RESEARCHER.REJECT') },
                    ]}
                    onChangeValue={onChangeResult}
                    required
                />
            </Grid>

            {caseReject()}
        </Grid>
    )
}

export default Approve
